import { useEffect } from 'react';
import logger from 'lc-logger';
import appConfig from 'lc-app-config';
import { Grid } from '@ui-propulsion/react-components';
import WebsiteComponent from '../../../components/websiteComponent/websiteComponent';
import csrf from '../../../services/helpers/csrf';
import render404Page from '../../../services/helpers/render404Page';
import LandingPagesService from '../../../services/landing-pages';
import styles from '../../../styles/main.module.scss';
import helpStyles from '../../../styles/help.module.scss';
import Breadcumbs from '../../../components/breadcrumbs/breadcrumbs';
import HelpTitle from '../../../components/helpTitle/helpTitle';
import HelpCenterSearch from '../../../components/helpCenterSearch/helpCenterSearch';
import trackHeapEvent from '../../../services/helpers/trackHeapEvent';
import { getOptimizelyUserExperiments } from '../../../services/helpers/common';

export default function Page({ title, titleIcon, components, experiments }) {
  useEffect(() => {
    trackHeapEvent(
      {
        Title: 'Page Load',
        Page: `Help - ${title}`,
      },
      `CMS_Unification`,
      experiments
    );
  }, [title, experiments]);
  return (
    <main className={styles.main}>
      <div className={styles.container}>
        <div className={styles.section}>
          <div className={helpStyles.breadcrumbs}>
            <Breadcumbs links={[{ label: 'Help Center', link: '/help' }]} />
          </div>
          <Grid container>
            <Grid item xs={12} sm={8}>
              <div className={helpStyles.categoryTitle}>
                <HelpTitle
                  {...{
                    title,
                    titleIcon,
                  }}
                />
              </div>
            </Grid>
            <Grid item xs={12} sm={4}>
              <HelpCenterSearch
                placeholder="Search"
                onEnter={(query) => {
                  window.location.assign(`/help/search?query=${query}`);
                }}
              />
            </Grid>
          </Grid>
        </div>
      </div>
      <div className={styles.landingPage}>
        <div className={styles.components}>
          {components.map((component, index) => {
            const key = `${component.type}-${index}`;

            return (
              <div key={key} id={component.id ?? key}>
                <WebsiteComponent {...component} />
              </div>
            );
          })}
        </div>
      </div>
    </main>
  );
}

export async function getServerSideProps(context) {
  const { category } = context.params;
  const slug = `help/${category}`;
  const userVariation = getOptimizelyUserExperiments(context.req.headers);

  const landingPagesService = new LandingPagesService(context.preview);
  const props = await landingPagesService.getPageTemplateBySlug(
    slug,
    userVariation
  );
  if (!props) {
    logger.info(
      {
        statusCode: 404,
        slug,
      },
      `LC-WEBSITE: Page not found for Slug`
    );
    return render404Page(context);
  }
  logger.info(
    {
      statusCode: 200,
      slug,
    },
    `LC-WEBSITE: Generating page for Slug`
  );

  const spaceId = appConfig.get('CONTENTFUL_SPACE_ID');
  const csrfToken = await csrf(context.req, context.res);
  return {
    props: {
      ...props,
      isPreview: !!context.preview,
      spaceId,
      csrfToken,
      experiments: Object.fromEntries(userVariation),
    },
  };
}
